export enum CancellationReasonEnum {
  // For "Bulletin d'inscription" not yet confirmed.
  CANCELLATION_BY_LEC_COMPLETE_STAY = 'CANCELLATION_BY_LEC_COMPLETE_STAY', // Annulation par LEC - Séjour complet
  CANCELLATION_BY_LEC_COMPLETE_TRIP = 'CANCELLATION_BY_LEC_COMPLETE_TRIP', // Annulation par LEC - Voyage complet
  CANCELLATION_BY_LEC_YOUTH_PROFILE_INCOMPATIBLE_WITH_STAY = 'CANCELLATION_BY_LEC_YOUTH_PROFILE_INCOMPATIBLE_WITH_STAY', // Annulation par LEC - Profil jeune incompatible avec séjour
  CANCELLATION_BY_LEC_CONTRADICTORY_PROCEDURE = 'CANCELLATION_BY_LEC_CONTRADICTORY_PROCEDURE', // Annulation par LEC - Procédure contradictoire
  CANCELLATION_BY_LEC_TEST = 'CANCELLATION_BY_LEC_TEST', // Annulation par LEC - Test
  CANCELLATION_BY_CLIENT_CHANGED_MIND_NO_FOLLOW_UP = 'CANCELLATION_BY_CLIENT_CHANGED_MIND_NO_FOLLOW_UP', // Annulation par client - A changé d'avis / sans suite
  // For actual registrants who cancel after validation
  CANCELLATION_BY_LEC_FOREIGN_PROD_CONSTRAINT = 'CANCELLATION_BY_LEC_FOREIGN_PROD_CONSTRAINT', // Annulation par LEC - contrainte prod ETR
  CANCELLATION_BY_LEC_LACK_OF_STAFF_FOREIGN = 'CANCELLATION_BY_LEC_LACK_OF_STAFF_FOREIGN', // Annulation par LEC : manque d'effectifs ETR
  CANCELLATION_BY_LEC_TRIP_PROD_CONSTRAINT = 'CANCELLATION_BY_LEC_TRIP_PROD_CONSTRAINT', // Annulation par LEC - contrainte prod voyage
  CANCELLATION_BY_LEC_LACK_OF_STAFF_TRIP = 'CANCELLATION_BY_LEC_LACK_OF_STAFF_TRIP', // Annulation par LEC : manque d'effectifs voyage
  CANCELLATION_BY_CLIENT_HEALTH = 'CANCELLATION_BY_CLIENT_HEALTH', // Annulation par client - santé
  CANCELLATION_BY_CLIENT_PAPERWORK_PERSONAL_REASON = 'CANCELLATION_BY_CLIENT_PAPERWORK_PERSONAL_REASON' // Annulation par client - papiers, raison personnelle
}

export const cancellationReasonEnumMapping: Record<CancellationReasonEnum, string> = {
  [CancellationReasonEnum.CANCELLATION_BY_LEC_COMPLETE_STAY]:
    'Annulation par LEC - Séjour complet',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_COMPLETE_TRIP]:
    'Annulation par LEC - Voyage complet',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_YOUTH_PROFILE_INCOMPATIBLE_WITH_STAY]:
    'Annulation par LEC - Profil jeune incompatible avec séjour',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_CONTRADICTORY_PROCEDURE]:
    'Annulation par LEC - Procédure contradictoire',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_TEST]: 'Annulation par LEC - Test',
  [CancellationReasonEnum.CANCELLATION_BY_CLIENT_CHANGED_MIND_NO_FOLLOW_UP]:
    "Annulation par client - A changé d'avis / sans suite",
  [CancellationReasonEnum.CANCELLATION_BY_LEC_FOREIGN_PROD_CONSTRAINT]:
    'Annulation par LEC - contrainte prod ETR',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_LACK_OF_STAFF_FOREIGN]:
    "Annulation par LEC : manque d'effectifs ETR",
  [CancellationReasonEnum.CANCELLATION_BY_LEC_TRIP_PROD_CONSTRAINT]:
    'Annulation par LEC - contrainte prod voyage',
  [CancellationReasonEnum.CANCELLATION_BY_LEC_LACK_OF_STAFF_TRIP]:
    "Annulation par LEC : manque d'effectifs voyage",
  [CancellationReasonEnum.CANCELLATION_BY_CLIENT_HEALTH]: 'Annulation par client - santé',
  [CancellationReasonEnum.CANCELLATION_BY_CLIENT_PAPERWORK_PERSONAL_REASON]:
    'Annulation par client - papiers, raison personnelle'
}
